/**
 * Toast 的 Context、类型与取用 Hook
 * 和组件分开放，是为了让 toast.tsx 只导出组件，热更新时不会整页刷新。
 */
import { createContext, useContext } from 'react';

export type ToastApi = {
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
};

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast 必须在 <ToastProvider> 内部使用');
  }
  return context;
}
